export const useStyles = () => {
  return {
    actions: {
      justifyContent: 'space-between',
    },
    timer: {
      display: 'flex',

      countdownText: {
        position: 'relative',
        left: '8px',
        top: '-1px',
        fontWeight: 700,
        fontSize: 18,
        display: 'inline-box',
      },
    },
  };
};
